import React, { useState } from 'react';
import './FAQ.css';

const faqs = [
  {
    question: 'How long does it take to build a project?',
    answer: 'We typically deliver MVPs within 2–4 weeks. Full-featured products may take longer depending on scope and complexity.',
  },
  {
    question: 'Can I edit the AI-generated quotation?',
    answer: 'Yes! You can review and modify the quotation before submitting. Our team will contact you to confirm the final details.',
  },
  {
    question: 'Is there a cost to generate a quotation?',
    answer: 'No. The quotation tool is free to use and gives you an estimate instantly without commitment.',
  },
  {
    question: 'Do you work with startups or enterprises?',
    answer: 'Both! Whether you’re launching your first MVP or scaling an existing platform, we adapt to your needs.',
  },
  {
    question: 'What tech stack do you use?',
    answer: 'We use modern stacks like React, Flutter, Node.js, Firebase, PostgreSQL, and various AI APIs including OpenAI.',
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      <div className="faq-hero">
        <h1 className="faq-title">Frequently Asked Questions</h1>
        <p className="faq-subtitle">Everything you need to know before getting started with Skript.</p>
      </div>

      <div className="faq-list">
        {faqs.map((item, index) => (
          <div
            key={index}
            className={`faq-item ${openIndex === index ? 'open' : ''}`}
            onClick={() => toggle(index)}
          >
            <div className="faq-question">
              <span>{item.question}</span>
              <span className="faq-toggle">{openIndex === index ? '–' : '+'}</span>
            </div>
            {openIndex === index && <div className="faq-answer">{item.answer}</div>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
